import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import { joinClasses, accessNested } from 'utils/utils';
import Youtube from 'components/shared/youtube/youtube';
import { Link } from 'components/core/link/link';
import Button from 'components/shared/button/button';
import Signup from 'components/pages/hub/signup';
import s from 'components/pages/about/about.sss';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class About extends Component {
	constructor(props) {
		super(props);

		this.$videos = {};
		this.steps = [25, 50, 75, 100];

		this.state = {
			reached: 0
		};

		this.handlePlay   = this.handlePlay.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
		window.trackButton = (action, category, label) => {
			Store.emit(actions.POWSTER_GA_EVENT_TRACK, action, category, label);
		}

		if (this.bgVideo && this.bgVideo.paused) {
			this.bgVideo.play();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handlePlay(ytid) {
		Object.entries(this.$videos).map(([id, video]) => {
			if (id !== ytid) {
				video.pause();
			}
		});
	}

	handleScroll() {
		const { reached } = this.state;

		const scrollTop = window.pageYOffset;
		const pageHeight = this.page.getBoundingClientRect().height;
		const diff = pageHeight - window.innerHeight;

		let percent = Math.round(scrollTop / diff * 100);
		if (diff <= 0) {
			percent = 100;
		}

		this.steps.forEach(step => {
			if (percent >= step && reached < step) {
				Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'page-scroll-depth', 'about', step);
				this.setState({ reached: step });
			}
		});
	}

	renderIntro(data, client) {
		const {
			background = {},
			title      = '',
			content    = '',
			sponsor    = {},
			media      = {},
			subContent = '',
			buttons    = {}
		} = data;

		const resolution = client.deviceSize === 'desktop' ? 'desktop' : 'mobile';
		const mediaSrc   = background.src[resolution];
		const isVideo    = mediaSrc.endsWith('mp4');
		// const posterSrc  = background.poster[resolution] || '';

		const bg = isVideo ?
			<video
				ref={ref => this.bgVideo = ref}
				class={s.video}
				src={mediaSrc}
				autoplay
				muted
				playsinline
				loop
				ariaLabel={background.ariaLabel}
				crossorigin='anonymous'
				// poster={posterSrc}
			/>
			: <img class={s.image} src={mediaSrc} alt={background.alt} />

		return (
			<section class={joinClasses(s.section, s.intro)} id="intro">
				<HTML class={s.title} tag='h1'>{title}</HTML>
				<div class={s.background}>
					{bg}
				</div>
				<HTML class={s.content} markdown>{content}</HTML>
				{sponsor?.src && (
					<div class={s.sponsor}>
						<Link
							renderCustomChild
							ariaLabel={sponsor.ariaLabel}
							href={sponsor.href}
							target='_blank'
							title={sponsor.title}
							rel='noopener'
							extraOnClick={() => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'partner_click', 'navigation', sponsor.id) }
						>
							<img class={s.logo} src={sponsor.src} alt={sponsor.alt} />
						</Link>
						<HTML tag='p' class={s.description}>{sponsor.description}</HTML>
					</div>
				)}
				<HTML class={s.content} markdown>{subContent}</HTML>
				{this.renderMedia(media)}
				<div class={s.buttons}>
					{Object.values(buttons).map(button => {
						const label = button.label.split(' ').join('-').toLowerCase();
						const extraOnClick = () => Store.emit(actions.POWSTER_GA_EVENT_TRACK, label + '_click', 'about', 'X');
						return <Button data={button} client={client} extraOnClick={extraOnClick}/>;
					})}
				</div>
			</section>
		);
	}

	renderSection(data, id) {
		const {
			title   = '',
			media   = {},
			content = '',
			sponsor,
			buttons
		} = data;

		return (
			<section class={joinClasses(s.section, s[id])} id={id}>
				<HTML class={s.title} tag='h1'>{title}</HTML>
				{this.renderMedia(media)}
				<HTML class={s.content} markdown>{content}</HTML>
				{buttons && (
					<div class={s.buttons}>
						{Object.values(buttons).map(button => {
							const label = button.label.split(' ').join('-').toLowerCase();
							const extraOnClick = () => Store.emit(actions.POWSTER_GA_EVENT_TRACK, label + '_click', 'about', 'X');
							return <Button data={button} client={this.props.client} extraOnClick={extraOnClick} />;
						})}
					</div>
				)}
				{sponsor?.src && (
					<div class={s.sponsor}>
						<Link
							renderCustomChild
							ariaLabel={sponsor.ariaLabel}
							href={sponsor.href}
							target='_blank'
							title={sponsor.title}
							rel='noopener'
							extraOnClick={() => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'partner_click', 'navigation', sponsor.id) }
						>
							<img class={s.logo} src={sponsor.src} alt={sponsor.alt} />
						</Link>
						<HTML tag='p' class={s.description}>{sponsor.description}</HTML>
					</div>
				)}
			</section>
		);
	}

	renderMedia(data) {
		const {
			ytid   = '',
			src    = '',
			alt    = '',
			credit = ''
		} = data;

		const media = ytid ?
			<Youtube
				ref={ref => this.$videos[ytid] = ref}
				class={s.playerWrapper}
				wrapperClass={s.youtube}
				activeItem={{ ytid: ytid }}
				autoplay={false}
				onPlay={this.handlePlay.bind(true, ytid)}
				appData={this.props.appData}
			/>
			: <img src={src} alt={alt} />
		
		return (
			<div class={s.media}>
				{media}
				<div class={s.credit}>{credit}</div>
			</div>
		);
	}

	render({ appData, pageData, client }) {
		const {
			intro  = {},
			how    = {},
			screen = {}
		} = pageData;

		const signup = accessNested(appData, 'pages.hub.data.sections.signUp');

		return (
			<main class={s.wrapper} ref={ref => this.page = ref}>
				{this.renderIntro(intro, client)}
				{this.renderSection(how, 'how')}
				{this.renderSection(screen, 'screen')}
				<Signup data={signup} />
			</main>
		);
	}
}
